import { Router } from 'pouter';

import RgbDuck from 'app/tyler/ducks/rgb';

import {
  Pages,
} from 'app/constants';

const createRouter = (store) => {
  const router = new Router();
  router.setContext({store});

  router.use('/', (done, location, _context, preRendered) => {
    if (preRendered) return;
    return done({page: Pages.TYLER_HOME});
  });

  router.use('/browser-not-supported', (done, _location, _context, preRendered) => {
    if (preRendered) return;
    done({page: Pages.BROWSER_NOT_SUPPORTED});
  });

  router.use('/rgb', (done, location, context, preRendered) => {
    if (preRendered) return;
    store.dispatch(RgbDuck.Ax.loadPage(location));
    done({page: Pages.TYLER_RGB});
  });

  router.use('/calc', (done, location, context, preRendered) => {
    if (preRendered) return;
    done({page: Pages.TYLER_CALC});
  });

  router.use('/signs', (done, location, context, preRendered) => {
    if (preRendered) return;
    done({page: Pages.TYLER_MOON});
  });

  return router;
};

export default createRouter;
